import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { gridSpacing } from '../../../store/constants';
import { FormLabel, Grid } from '@mui/material';
import { subCounties, serviceTypes } from '../../../utils';
import { toTitleCase } from '../../post_login/summary';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import MuiPickersUtilsProvider from '@material-ui/pickers';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { DateRangePicker } from "react-dates";
import DateFnsUtils from '@date-io/date-fns';
import dayjs, { Dayjs } from 'dayjs';
import moment from "moment/moment";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Button } from "@mui/material";
import { dateFormatter } from '../../../utils';

export default function FilterComponent({ setEndDate, setStartDate, setSubCounty, setServiceType }) {
    const [selectedValues, setSelectedValues] = React.useState({
        subCounty: '',
        serviceType: ' '
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setSelectedValues(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    return (
        <div>
            <Grid container spacing={gridSpacing}>
                <Grid item sm={6} sx={{ display: 'flex', alignItems: 'center' }} xs={12} md={4} lg={3}>
                    <FormControl required sx={{ m: .1, width: '100%' }}>
                        <FormLabel variant='' id="" sx={{ mb: 1, fontWeight: 700, fontSize: 13 }}>Sub-county</FormLabel>
                        <Select
                            sx={{ mb: 1, fontWeight: 700, fontSize: 13 }}
                            labelId="demo-simple-select-required-label"
                            id="subCounty"
                            name="subCounty"
                            value={selectedValues.subCounty}
                            onChange={(e) => {
                                handleChange(e)
                                setSubCounty(e.target.value)
                            }}
                        >
                            <MenuItem sx={{ mb: 1, fontWeight: 700, fontSize: 13 }} value="All"> <em>All</em></MenuItem>
                            {subCounties.map((value, index) => (
                                <MenuItem key={index} sx={{ mb: 1, fontWeight: 700, fontSize: 13 }} value={value.SUBCOUNTY_NAME}>{toTitleCase(value.SUBCOUNTY_NAME)}</MenuItem>
                            ))}

                        </Select>
                    </FormControl>
                </Grid>
                <Grid item sm={6} sx={{ display: 'flex', alignItems: 'center' }} xs={12} md={4} lg={3}>
                    <FormControl required sx={{ m: 1, width: '100%' }}>
                        <FormLabel variant='filled' id="" sx={{ mb: 1, fontWeight: 700, fontSize: 13 }}>Service Type</FormLabel>
                        <Select
                            sx={{ mb: 1, fontWeight: 700, fontSize: 13 }}
                            labelId="demo-simple-select-service-type"
                            id="serviceType"
                            name="serviceType"
                            value={selectedValues.serviceType}
                            label=""
                            onChange={(e) => {
                                handleChange(e)
                                setServiceType(e.target.value)
                            }}
                        >
                            <MenuItem sx={{ mb: 1, fontWeight: 700, fontSize: 13 }} value="All"> <em>All</em></MenuItem>
                            {serviceTypes.map((value, index) => (
                                <MenuItem key={index} sx={{ mb: 1, fontWeight: 700, fontSize: 13 }} value={value.serviceType}>{toTitleCase(value.title)}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item sm={6} sx={{ display: 'flex', alignItems: 'center' }} xs={12} md={4} lg={3}>
                    <FormControl required sx={{ mb: 1, width: '100%' }}>
                        <FormLabel variant='filled' id="" sx={{ mb: 0, fontWeight: 700, fontSize: 13 }}>From</FormLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer
                                components={[
                                    'DatePicker',
                                    'MobileDatePicker',
                                    'DesktopDatePicker',
                                    'StaticDatePicker',
                                ]}
                            >
                                <DesktopDatePicker defaultValue={""}
                                    onChange={(date) => {
                                        var backDate = new Date(date);
                                        backDate.setDate(backDate.getDate() + 1);
                                        var newDateString = backDate.toISOString().slice(0, 10);
                                        setStartDate(dateFormatter(newDateString))
                                    }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </FormControl>
                </Grid>
                <Grid item sm={6} sx={{ display: 'flex', alignItems: 'center' }} xs={12} md={4} lg={3}>
                    <FormControl required sx={{ mb: 1, width: '100%' }}>
                        <FormLabel variant='filled' id="" sx={{ mb: 0, fontWeight: 700, fontSize: 13 }}>To</FormLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer
                                components={[
                                    'DatePicker',
                                    'MobileDatePicker',
                                    'DesktopDatePicker',
                                    'StaticDatePicker',
                                ]}
                            >
                                <DesktopDatePicker defaultValue={""}
                                    onChange={(date) => {
                                        var backDate = new Date(date);
                                        backDate.setDate(backDate.getDate() + 1);
                                        var newDateString = backDate.toISOString().slice(0, 10);
                                        setEndDate(dateFormatter(newDateString))
                                    }
                                    }

                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </FormControl>
                </Grid>
                {/* <Grid item sm={6}sx={{display: 'flex', alignItems:'center'}}  xs={12} md={4} lg={1.5}>
                    <FormControl required sx={{  mb:-1.8, width: '100%' }}>
                        <Button sx={{ backgroundColor: "#E8B40A", fontWeight: 900, fontSize: 11, height:47 }} variant="contained" size="large"> Search </Button>
                    </FormControl>
                </Grid>
                <Grid item sm={6} sx={{display: 'flex', alignItems:'center'}} xs={12} md={4} lg={1.5}>
                    <FormControl required sx={{ mb:-1.8, width: '100%' }}>
                        <Button sx={{ backgroundColor: "#000", fontWeight: 900, fontSize: 11, height:47 }} variant="contained" size="large"> Export </Button>
                    </FormControl>
                </Grid> */}
            </Grid>

        </div>
    );
}